import {
    Box,
    styled,
    Typography,
    Avatar,
    Hidden,
    Button,
    Paper,
} from '@mui/material';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import { intervalToDuration } from 'date-fns';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: '1rem',
    margin: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover, &:focus': {
        cursor: 'pointer',
        boxShadow:
            '0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12)',
    },
    [theme.breakpoints.down('sm')]: {
        margin: '2rem .3rem',
    },
    [theme.breakpoints.up('sm')]: {
        maxWidth: '45rem',
        margin: '2rem auto',
    },
}));

const JobComponent = props => {
    const calculateDisplay = time => {
        const duration = intervalToDuration({
            start: time,
            end: new Date(Date.now()),
        });
        if (duration.months > 0) {
            return `${duration.months} month${
                duration.months > 1 ? '' : 's'
            } ago`;
        }
        if (duration.weeks > 0) {
            return `${duration.weeks} week${duration.weeks > 1 ? 's' : ''} ago`;
        }
        if (duration.days > 0) {
            return `${duration.days} day${duration.hours > 1 ? 's' : ''} ago`;
        }
        if (duration.days === 0) {
            return `${duration.hours} hour${
                duration.hours === 0 || duration.hours > 1 ? 's' : ''
            } ago`;
        }
    };

    return (
        <StyledPaper
            elevation={3}
            onClick={() => props.viewJob(props.id)}
            key={props.id}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'start',
                }}
            >
                <Box>
                    <Avatar
                        sx={{
                            width: '50px',
                            height: '50px',
                            boxShadow:
                                '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)',
                        }}
                        src={props.schoolLogo}
                    ></Avatar>
                    <Typography
                        variant="body2"
                        sx={{
                            marginTop: '8px',
                        }}
                    >
                        {calculateDisplay(props.postDate)}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        textAlign: 'left',
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            marginLeft: '1rem',
                        }}
                    >
                        {props.jobTitle}
                    </Typography>

                    <Typography
                        variant="subtitle2"
                        sx={{
                            marginLeft: '1rem',
                        }}
                    >
                        {props.schoolName} - {props.typeOfJob}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            margin: '4px 0rem 0rem 1rem',
                        }}
                    >
                        {props.location.split(',')[1]}
                    </Typography>
                </Box>
            </Box>
            <Hidden smUp>
                <KeyboardBackspaceOutlinedIcon
                    sx={{
                        color: '#4632da',
                        rotate: '180deg',
                    }}
                />
            </Hidden>
            <Hidden smDown>
                <Button
                    sx={{
                        color: '#4632da',
                    }}
                >
                    View Details
                </Button>
            </Hidden>
        </StyledPaper>
    );
};

export default JobComponent;
